import { render, staticRenderFns } from "./DialogPage.vue?vue&type=template&id=5e9b19a7&scoped=true&"
import script from "./DialogPage.vue?vue&type=script&lang=ts&"
export * from "./DialogPage.vue?vue&type=script&lang=ts&"
import style0 from "./DialogPage.vue?vue&type=style&index=0&id=5e9b19a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9b19a7",
  null
  
)

export default component.exports